import z from 'zod'

export const standardAccount = z.coerce.number().min(1000).max(9999)
export type StandardAccount = z.infer<typeof standardAccount>

export const standardAccountRange = z
	.array(standardAccount)
	.length(2)
	.refine((arr) => arr[0] <= arr[1], {
		message: 'Invalid account range: start must be less than or equal to end',
	})
